<template>
  <layout-public>
    <page-meta />

    <page-hero
      :crumbs="[{ label: t('Home'), href: route('index') }, { label: t('Portfolios') }]"
      :title="t('Web Design Portfolio')"
      :lede="t('Every website here was designed, built and hosted by us. Open one to see what the project needed and how we approached the build.')"
    />

    <section class="portfolio-list">
      <div class="container">
        <!-- The pager belongs to the results, so it rides inside them: a list
             with nothing in it has no range to page and the empty message is the
             whole answer. One page still renders the row, so the pager shows for
             a single page too, the same as the blog and promotions listings. The
             card is silent about where it came from, so the listing and the home
             band render one card. -->
        <template v-if="projects.data.length">
          <div class="row">
            <div
              v-for="project in projects.data"
              :key="project.slug"
              class="col-md-6 col-lg-4"
              data-aos="fade-up"
            >
              <portfolio-card :project="project" />
            </div>
          </div>

          <pagination :links="projects.links" />
        </template>

        <div v-else class="row">
          <div class="col-12 text-center">
            <p class="text-muted mb-0">{{ t('No projects yet.') }}</p>
          </div>
        </div>
      </div>
    </section>
  </layout-public>
</template>

<script>
import { useI18n } from 'vue-i18n';
import PageMeta from '@/Components/PageMeta.vue';
import LayoutPublic from '@/Layouts/Public.vue';
import PageHero from '@/Components/PageHero.vue';
import Pagination from '@/Components/Pagination.vue';
import PortfolioCard from '@/Components/PortfolioCard.vue';
import { portfolioMessages } from '@/i18n/portfolios';

export default {
  components: {
    LayoutPublic,
    PageHero,
    PageMeta,
    Pagination,
    PortfolioCard
  },

  props: {
    /* The paginator from PortfolioController: `data` is this page's projects and
       `links` is the pager, which is the same shape Blog/Index.vue and
       Promotions/Index.vue read. The home band and the web design page take the
       featured projects as a plain array instead, because a band is not a
       listing and has no pages. */
    projects: {
      type: Object,
      required: true
    }
  },

  setup() {
    /* The portfolio's own words, from the portfolio's one dictionary. The hero's
       title and lede are the only two this page adds to it; `Portfolios` in the
       crumb is shared vocabulary and resolves from the root composer, which is
       where the header and the footer read the same three words. */
    const { t } = useI18n({ messages: portfolioMessages });

    return { t };
  }
};
</script>
